import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import ImageCarousel from 'LuxKit/Carousel/ImageCarousel'
import config from 'constants/config'
import Image from 'components/Common/Image'
import { useIsMobileDevice } from 'hooks/useIsMobileDevice'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import ExperienceCategoryLabel from './ExperienceCategoryLabel'

const Root = styled.div`
  display: flex;
  position: relative;
`

const BadgeContainer = styled.div`
  position: absolute;
  top: ${rem(12)};
  inset-inline-start: ${rem(12)};
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  > * + * {
    margin-top: ${rem(8)};
  }
`

const RightSideBadge = styled.div`
  position: absolute;
  top: ${rem(12)};
  inset-inline-end: ${rem(12)};
`

interface Props {
  experience: App.ExperienceOffer
  partnershipBadge?: boolean
  addedBadge?: boolean
}

function ExperienceImageCarousel(props: Props) {
  const {
    experience,
    addedBadge,
  } = props

  const intl = useIntl()
  const isMobileDevice = useIsMobileDevice()
  // Swiping through the offer tiles is tough when the image carousel can also swipe.
  // It might also break the page due to memory limits when scrolling too many tiles.
  // So turn off the image carousel for mobile devices
  const images = useMemo(() => isMobileDevice ? [experience.images[0]] : experience.images, [isMobileDevice, experience.images])

  return (
    <Root>
      <ImageCarousel
        images={images}
      />
      <BadgeContainer>
        {addedBadge && <StatusLabel variant="added" startIcon={<LineCheckIcon />}>{intl.formatMessage({
          id: 'sTPxbtFOjuf6srHt7L9S',
          defaultMessage: 'Added',
          description: 'Badge label indicating experience has been added to trip',
        })}
        </StatusLabel>}
        <div>
          <LabelGroup>
            <ExperienceCategoryLabel categories={experience.categories} />
          </LabelGroup>
        </div>
      </BadgeContainer>
      {config.EXPERIENCE_BADGE_IMAGE_ID && <RightSideBadge>
        <Image id={config.EXPERIENCE_BADGE_IMAGE_ID} height={80} width={80} />
      </RightSideBadge>}
    </Root>
  )
}

export default ExperienceImageCarousel
